import { render, staticRenderFns } from "./BodySizeCreateEdit.vue?vue&type=template&id=2785468a&scoped=true&"
import script from "./BodySizeCreateEdit.vue?vue&type=script&lang=js&"
export * from "./BodySizeCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./BodySizeCreateEdit.vue?vue&type=style&index=0&id=2785468a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2785468a",
  null
  
)

export default component.exports